import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', name: 'homePage', component: require(page+'home.vue').default },
      { path: '/empresa', component: require(page+'company/index.vue').default, meta:{ title:"Empresa" } },
      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{ title:"Contacto" } },

      { path: '/servicios', component: require(page+'services/index.vue').default, meta:{ title:"Servicios" } },
      { path: '/servicios/macetas-de-plastico-para-cultivo', component: require(page+'services/macetas-de-plastico-cultivo.vue').default, meta:{ title:"Macetas de plastico para cultivo" } },
      { path: '/servicios/macetas-de-plastico-decorativas', component: require(page+'services/macetas-de-plastico-decorativas.vue').default, meta:{ title:"Macetas de plastico decorativas" } },
      { path: '/servicios/diseno-de-moldes-de-inyeccion', component: require(page+'services/diseno-moldes.vue').default, meta:{ title:"Diseño de moldes de inyeccion" } },
      { path: '/servicios/inyeccion-y-maquila', component: require(page+'services/inyeccion-y-maquila.vue').default, meta:{ title:"Inyeccion y maquila de plastico" } },
      { path: '/servicios/proyectos-e-ingenieria', component: require(page+'services/proyectos-e-ingenieria.vue').default, meta:{ title:"Proyectos e ingenieria" } },
      { path: '/servicios/que-es-la-inyeccion-de-plasticos', component: require(page+'services/que-es-inyeccion-de-plasticos.vue').default, meta:{ title:"¿Qué es la inyección de plásticos?" } },
      { path: '/servicios/que-es-un-molde-de-inyeccion', component: require(page+'services/que-es-un-molde-de-inyeccion.vue').default, meta:{ title:"¿Qué es un molde de inyeccion?" } },

      { path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{ title:"Aviso de privacidad" } },

      { path: '/busqueda', component: require(page+'products/search.vue').default, meta:{ title:"Búsqueda de productos" } },
      { path: '/categoria/:id', component: require(page+'products/results.vue').default, meta:{ title:"Productos" } },
      { path: '/subcategoria/:id', component: require(page+'products/results.vue').default, meta:{ title:"Productos" } },
      { path: '/producto/:id', component: require(page+'products/description.vue').default, meta:{ title:"Producto" } },

      { path: '/blog', component: require(page+'blog/index.vue').default, meta:{ title:"Blog" } },
      { path: '/blog/:id', component: require(page+'blog/detail.vue').default, meta:{ title:"Blog" } },

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "PPI", filter: (title)=>{ return title+" - PPI"; } }
);

// export {routes};
export default MyRouter;
